import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import './index.scss';
import './styles/custom-tokens.css';
import './styles/celebration-override.scss';
import '@celebration/design-tokens/dist/scss/at/light.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './utils/authConfig';
import { ToastContextProvider } from '@celebration/react';
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function (child) {
  if (child.parentNode !== this) {
    return child;
  }
  return originalRemoveChild.call(this, child);
};

const originalInsertBefore = Node.prototype.insertBefore;
Node.prototype.insertBefore = function (newNode, referenceNode) {
  if (referenceNode && referenceNode.parentNode !== this) {
    return newNode;
  }
  return originalInsertBefore.call(this, newNode, referenceNode);
};

const CHUNK_ERROR_KEY = 'chunkErrorReloaded';

const isChunkLoadError = error => {
  if (!error) return false;
  if (error.name === 'ChunkLoadError') return true;
  const msg = typeof error === 'string' ? error : error.message || '';
  return (
    msg.includes('Loading CSS chunk') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError')
  );
};

const reloadOnChunkError = () => {
  if (sessionStorage.getItem(CHUNK_ERROR_KEY)) {
    sessionStorage.removeItem(CHUNK_ERROR_KEY);
    return;
  }
  sessionStorage.setItem(CHUNK_ERROR_KEY, '1');
  window.location.reload();
};

window.addEventListener('unhandledrejection', event => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault();
    reloadOnChunkError();
  }
});

const originalWindowOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (typeof message === 'string' && message.includes('ResizeObserver loop completed')) {
    return true;
  }
  if (isChunkLoadError(error) || isChunkLoadError(message)) {
    reloadOnChunkError();
    return true;
  }
  return originalWindowOnError?.apply(this, [message, source, lineno, colno, error]);
};

window.addEventListener('load', () => {
  sessionStorage.removeItem(CHUNK_ERROR_KEY);
});

const msalInstance = new PublicClientApplication(msalConfig);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <MsalProvider instance={msalInstance}>
    <ToastContextProvider>
      <App />
    </ToastContextProvider>
  </MsalProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

